import React, { useState } from "react";
import { FormGroup, Label, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import usePaging from "../../hooks/usePaging";
import useFetcher from "../../hooks/useFetcher";
import { fetchTicketingCategories, fetchTickets, fetchPiAsignable } from "../../services/ticketingServices";
import { StyledSelect } from "../StyledSelect";
import SpinnerButton from "../Button";

const BehalfModal = ({ formik, toggle, isOnBehalf, setisOnBehalf }) => {
  const pagingController = usePaging(fetchTickets);
  const [selectedPI, setSelectedPI] = useState(false);
  const [piAsignable, isLoadingPiAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [ticketingCategories, isLoadingTicketingCategories] = useFetcher(fetchTicketingCategories, undefined, "fetchTicketingCategories");

  const handleReactSelectChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.value : null };
    if (newState.region) {
      newState.sucursal = null;
    }
    if ((newState.categoria && newState.categoria === 4) || newState.piAsignado) {
      setSelectedPI(true);
    } else {
      setSelectedPI(false);
    }
    pagingController.setFilterValue(newState);
  };

  const piAsignableOptions = piAsignable
    .map((pi) => {
      return { label: pi.nombreApellido, value: pi.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const categoriesOptions = ticketingCategories.categoria
    ? ticketingCategories.categoria
        .map((categoria) => {
          return { label: categoria.text, value: categoria.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  // Se filtra la categoria 4 "Personal interno" a pedido de cliente para CreadoPara
  // eslint-disable-next-line max-len
  // const filteredCategoriesOptions = categoriesOptions ? categoriesOptions.filter((categoria) => categoria.value !== 4) : [];

  return (
    <Modal isOpen toggle={toggle}>
      <ModalHeader toggle={toggle}> Creado para </ModalHeader>
      <ModalBody>
        <FormGroup className="d-flex justify-content-between">
          <p className="d-block mb-0" htmlFor="isOnBehalf">
            ¿Desea crear el ticket a nombre de otra persona?
          </p>
          <input
            style={{ marginLeft: "10px", marginTop: "2px" }}
            className="checkbox_animated_dark"
            id="isOnBehalf"
            name="isOnBehalf"
            type="checkbox"
            checked={isOnBehalf}
            onChange={() => setisOnBehalf(!isOnBehalf)}
          />
        </FormGroup>
        {isOnBehalf && (
          <>
            <FormGroup style={{ width: "193px" }}>
              <Label htmlFor="categoria" className="col-form-label pt-0 w-100">
                Publico
                <StyledSelect
                  id="categoria"
                  name="categoria"
                  className="w-100"
                  formik={formik}
                  onChange={handleReactSelectChange}
                  value={categoriesOptions.find((option) => {
                    return option.value === parseInt(pagingController.query.categoria, 10);
                  })}
                  placeholder="Todo"
                  isClearable
                  required
                  isLoading={isLoadingTicketingCategories}
                  disabled={isLoadingTicketingCategories}
                  options={categoriesOptions}
                />
              </Label>
              {formik.errors.categoria && formik.touched.categoria && <div className="input-feedback">{formik.errors.categoria}</div>}
            </FormGroup>
            {selectedPI ? (
              <FormGroup style={{ width: "193px" }}>
                <Label htmlFor="categoria" className="col-form-label pt-0 w-100">
                  Para:
                  <StyledSelect
                    id="piAsignado"
                    name="piAsignado"
                    className="w-100"
                    formik={formik}
                    onChange={handleReactSelectChange}
                    value={piAsignableOptions.find((option) => {
                      return option.value === parseInt(pagingController.query.piAsignado, 10);
                    })}
                    placeholder="Todos"
                    isClearable
                    required
                    isLoading={isLoadingPiAsignable}
                    disabled={isLoadingPiAsignable}
                    options={piAsignableOptions}
                  />
                </Label>
                {formik.errors.piAsignado && formik.touched.piAsignado && <div className="input-feedback">{formik.errors.piAsignado}</div>}
              </FormGroup>
            ) : (
              <>
                <div className="form-group">
                  <p className="form-label mb-1">Nombre</p>
                  <input
                    className="form-control"
                    type="string"
                    placeholder="Nombre"
                    name="nombre"
                    required
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.nombre}
                  />
                  {formik.errors.nombre && formik.touched.nombre && <div className="input-feedback">{formik.errors.nombre}</div>}
                </div>
                <div className="form-group">
                  <p className="form-label mb-1">Apellido</p>
                  <input
                    className="form-control"
                    type="string"
                    placeholder="Apellido"
                    name="apellido"
                    required
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.apellido}
                  />
                  {formik.errors.apellido && formik.touched.apellido && <div className="input-feedback">{formik.errors.apellido}</div>}
                </div>
                <div className="form-group">
                  <p className="form-label mb-1">DNI</p>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Numero de documento"
                    name="dniCreador"
                    required={formik.values.categoria === "1"}
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.dniCreador}
                  />
                  {formik.errors.dniCreador && formik.touched.dniCreador && <div className="input-feedback">{formik.errors.dniCreador}</div>}
                </div>
                <div className="form-group">
                  <p className="form-label mb-1">Email</p>
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Email"
                    name="email"
                    required
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.errors.email && formik.touched.email && <div className="input-feedback">{formik.errors.email}</div>}
                </div>
                <div className="form-group">
                  <p className="form-label mb-1">Telefono</p>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Telefono"
                    name="telefonoCreador"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.telefonoCreador}
                  />
                </div>
              </>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <FormGroup className="mb-0 px-3">
          <SpinnerButton className="btn btn-primary btn-block" isLoading={false} disabled={false} onClick={() => toggle()}>
            Guardar
          </SpinnerButton>
        </FormGroup>
      </ModalFooter>
    </Modal>
  );
};

export default BehalfModal;
